// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".abc2837f6947249c948bb3f4bc16f52802952ee6.chunk.js";
};